import { createContext, useContext, useEffect, useState } from "react";
import { useUserData } from "./userContext";
import { GridContext } from "./GridContext/GridContext";
import PropTypes from "prop-types";
import { stepLog_listByKeikkas } from "src/data/stepLog/stepLogClass";
import { reminderRules_List } from "src/data/keikkaReminderFunctions";
import { getYYYYMMDD } from "src/components/js/statics1";

const KeikkaRemindersContext = createContext();
export { KeikkaRemindersContext };

export const KeikkaRemindersProvider = ({ children }) => {
  const { token, ownerAsiakasId, isLoaded: userIsLoaded, auth } = useUserData();
  const {
    isLoaded: gridIsLoaded,
    dailyKeikat,
    keikat,
    setKeikat,
    fetchCount,
    time,
  } = useContext(GridContext) || {};
  const [reminderRules, setReminderRules] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userIsLoaded || !gridIsLoaded || !auth.action.keikka.create) return;
    // useEffect: load once reminderRules
    const fetchReminderRules = async () => {
      const rules = await reminderRules_List(ownerAsiakasId, token);
      setReminderRules(rules);
      setIsLoaded(true);
    };
    fetchReminderRules();
  }, [userIsLoaded, gridIsLoaded]);

  useEffect(() => {
    if (!isLoaded || !userIsLoaded || !gridIsLoaded || !dailyKeikat || dailyKeikat.length === 0)
      return;
    if (time.yyyymmdd < getYYYYMMDD(new Date())) return;
    // useEffect: load every time dailyKeikat changes (every time time changes)
    const fetchStepLogData = async (keikkaIds) => {
      setIsLoading(true);
      let didSetRules = false;
      const stepLogData = await stepLog_listByKeikkas(keikkaIds, token);
      // process reminderRules and stepLogData
      for (const keikka of dailyKeikat) {
        if (!keikka.isKeikka) continue;
        keikka.keikkaReminders = [];
        let rule_found = false;
        let rule_active = false;
        // loop rules
        for (const rule of reminderRules) {
          if (!rule.active) continue;
          const rule_requiredStepLogTypeId = rule.requiredStepLogTypeId;
          const rule_sourceAsiakasId = rule.keikkaSourceAsiakasId;
          if (rule_sourceAsiakasId !== keikka.sourceAsiakasId) continue;
          // loop stepLogData
          rule_active = true;
          for (const stepLog of stepLogData) {
            if (
              stepLog.keikkaId === keikka.keikkaId &&
              stepLog.stepLogTypeId === rule_requiredStepLogTypeId
            ) {
              rule_found = true;
              break;
            }
          }
          if (!rule_found && rule_active) {
            didSetRules = true;
            if (!keikka.keikkaReminders) keikka.keikkaReminders = [];
            keikka.keikkaReminders.push(rule);
          }
        }
      }
      if (didSetRules) setKeikat([...keikat]);
      setIsLoading(false);
    };

    const keikkaIds = dailyKeikat.map((keikka) => keikka.keikkaId).join(",");
    fetchStepLogData(keikkaIds);
  }, [isLoaded, userIsLoaded, gridIsLoaded, fetchCount]);

  return (
    <KeikkaRemindersContext.Provider value={{ isLoaded, isLoading }}>
      {children}
    </KeikkaRemindersContext.Provider>
  );
};

export const useKeikkaReminders = () => useContext(KeikkaRemindersContext);

KeikkaRemindersProvider.propTypes = {
  children: PropTypes.node,
};
